<mat-sidenav-container
  class="sidenav-container"
  [hasBackdrop]="true"
  (backdropClick)="toggleMobileSummary()"
>
  <section class="page-container" [ngClass]="[pageName]">
    <main
      *ngIf="loaded"
      class="main-wraper"
      [ngClass]="currentPageNumber < 0 ? 'page-start' : ''"
    >
      <section
        [@PageAnimation]="pageAnimationState"
        class="page-section"
        [ngClass]="(animationInProgress$ | async) ? 'no-scroll' : ''"
        [ngStyle]="getStyle()"
        #pageSection
      >
        <xilo-mono-form-viewer
          [fields]="fields"
          [form]="form"
          [formView]="formView"
          [options]="formOptions"
          [model]="formModel"
          (agentAssigned)="agentAssigned($event)"
          (showAlert)="onAlert($event)"
          (formCompleted)="onFormCompleted()"
        ></xilo-mono-form-viewer>
      </section>
      <div class="blurEffect"></div>
      <!-- [ngClass]="{ pushButtonUp: isNextButtonNeeded() }" -->
      <button
        [disabled]="(!nextButtonEnabled() && !(isLastQuestion() && form.valid)) || disableNextBtn || isSubmitting"
        (click)="onNextForm()"
        class="next-button"
        [ngClass]="{
          'done-adding-button': showAddAnother() && isLastQuestion()
        }"
      >
        <mat-spinner
          class="submit-spinner"
          *ngIf="isSubmitting"
          color="primary"
          [diameter]="25"
        ></mat-spinner>
        <p *ngIf="!isSubmitting"
          >{{ isLastQuestion() ? 'Submit' : 'Next' }}
        </p>
      </button>
      <ng-container *ngIf="!isMobile">
        <ng-template [ngTemplateOutlet]="summaryTemplate"></ng-template>
      </ng-container>
    </main>
  </section>
  <div
    class="mobile-summary-toggle closed"
    *ngIf="isMobile && !mobileSummaryOpened"
    (click)="toggleMobileSummary()"
  >
    <svg
      width="44"
      height="32"
      viewBox="0 0 44 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="44" height="32" rx="4" fill="#EBEBEB" />
      <path
        d="M20.3334 16H30.3334"
        stroke="#111111"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.3334 21.8333H30.3334"
        stroke="#111111"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.3334 10.1667H30.3334"
        stroke="#111111"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17 20.1667H13.6666V23.5H17V20.1667Z"
        stroke="#111111"
        stroke-width="1.5"
        stroke-linejoin="round"
      />
      <path
        d="M17 14.3333H13.6666V17.6666H17V14.3333Z"
        stroke="#111111"
        stroke-width="1.5"
        stroke-linejoin="round"
      />
      <path
        d="M17 8.5H13.6666V11.8333H17V8.5Z"
        stroke="#111111"
        stroke-width="1.5"
        stroke-linejoin="round"
      />
    </svg>
  </div>
  <div class="mobile-summary-toggle phone" *ngIf="isMobile && phoneNumber">
    <a class="flex" [href]="'tel:' + phoneNumber">
      <img src="assets/icon/phone-border.svg" /><span></span>
    </a>
  </div>
  <mat-sidenav
    class="summary-sidenav"
    [opened]="mobileSummaryOpened"
    mode="over"
    position="end"
    [autoFocus]="false"
    [fixedInViewport]="true"
  >
    <div class="mobile-summary-header">
      <div
        class="mobile-summary-toggle close-icon"
        [ngClass]="mobileSummaryOpened ? 'opened' : 'closed'"
        *ngIf="isMobile"
        (click)="toggleMobileSummary()"
      >
        <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="24" height="24" rx="2" fill="#EBEBEB"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.28432 5.28432C5.66341 4.90523 6.27805 4.90523 6.65714 5.28432L12 10.6272L17.3429 5.28432C17.722 4.90523 18.3366 4.90523 18.7157 5.28432C19.0948 5.66341 19.0948 6.27805 18.7157 6.65714L13.3728 12L18.7157 17.3429C19.0948 17.722 19.0948 18.3366 18.7157 18.7157C18.3366 19.0948 17.722 19.0948 17.3429 18.7157L12 13.3728L6.65714 18.7157C6.27805 19.0948 5.66341 19.0948 5.28432 18.7157C4.90523 18.3366 4.90523 17.722 5.28432 17.3429L10.6272 12L5.28432 6.65714C4.90523 6.27805 4.90523 5.66341 5.28432 5.28432Z" fill="#111111"/>
        </svg>
      </div>

      <h3 class="ml-4">Summary</h3>
    </div>
    <div class="mobile-summary-container">
      <ng-template [ngTemplateOutlet]="summaryTemplate"></ng-template>
    </div>
  </mat-sidenav>
  <!-- mobile footer navigation -->
  <div class="progress-bar-mobile">
    <app-mobile-footer-navigation
      [questions]="mobileQuestionSummary()"
      [currentQuestion]="(currentQuestionNumber || questionIndex) + 1"
      [totalQuestions]="currentSectionQuestionCount()"
      [previousEnabled]="previousButtonEnabled()"
      [showBannerOnMobile]="showBannerOnMobile"
      [nextEnabled]="nextButtonEnabled() && !isLastQuestion()"
      (previous)="previous()"
      (next)="onNextForm()"
    ></app-mobile-footer-navigation>
  </div>
  <app-footer [footerText]="footerText" *ngIf="footerText"></app-footer>
</mat-sidenav-container>

<ng-template #summaryTemplate>
  <section class="summary-section" [@SummaryAnimation]="summaryAnimationState">
    <app-summary
      *ngIf="formView"
      [formData]="formView"
      [currentForm]="form"
      [isMobile]="isMobile"
      [mainForm]="form"
      (deleteMultipleItemTrigger)="handleDeleteMultipleItemTrigger($event)"
    ></app-summary>
  </section>
</ng-template>
